export default __webpack_public_path__ + "static/media/WazeAppIcon.6c98de61.svg";